import React, { memo, useEffect, useRef } from "react";
import { ContactCard } from "../ContactCard";
import * as S from "../styles";
import { useMainState } from "modules/app/contexts";

function List({ section, EmptySection, total, handleLastContactVisible }) {
  const { forwardMode } = useMainState();
  const sentinelRef = useRef(null);

  const callbackFunction = (entries) => {
    const [entry] = entries;
    handleLastContactVisible(entry.isIntersecting);
  };

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.7,
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) {
        observer.unobserve(sentinelRef.current);
      }
    };
  }, [sentinelRef, options]);

  return (
    <>
      <S.Title>
        {forwardMode
          ? `Encaminhar Contatos`
          : total !== 0
          ? `${section.title} (${total})`
          : section.title}
      </S.Title>

      {section.items.length === 0 ? (
        <EmptySection />
      ) : (
        <>
          {section.items.map((contact) => (
            <ContactCard key={contact.id} contact={contact} />
          ))}
          {section.items.length < total && (
            <S.LoadingMore>
              <S.Sentinel ref={sentinelRef} />
            </S.LoadingMore>
          )}
        </>
      )}
    </>
  );
}

export default memo(List);
